import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomerMultiPromptTemplate,
  BackendMutationDuplicateCustomerMultiPromptTemplateArgs,
} from 'src/types/backend';

import { FRAGMENT_MULTI_PROMPT_TEMPLATE } from './schema';

const MUTATION = gql`
  mutation DuplicateCustomerMultiPromptTemplate($customerId: ID!, $workspaceId: ID!, $id: ID!) {
    duplicateCustomerMultiPromptTemplate(
      customerId: $customerId
      workspaceId: $workspaceId
      id: $id
    ) {
      ...CustomerMultiPromptTemplate
    }
  }
  ${FRAGMENT_MULTI_PROMPT_TEMPLATE}
`;

type Variables = BackendMutationDuplicateCustomerMultiPromptTemplateArgs;
type Result = BackendCustomerMultiPromptTemplate;

export const duplicateCustomerMultiPromptTemplate = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
